import { render, staticRenderFns } from "./DisabilitiesEdit.vue?vue&type=template&id=93d238c6&scoped=true&"
import script from "./DisabilitiesEdit.vue?vue&type=script&lang=js&"
export * from "./DisabilitiesEdit.vue?vue&type=script&lang=js&"
import style0 from "./DisabilitiesEdit.vue?vue&type=style&index=0&id=93d238c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d238c6",
  null
  
)

export default component.exports